import { WordCategory } from '~/containers/ManageWords/components/ManageWordsList';
import { emperor } from '~/services';

export const getForbiddenAndModeratedWords = async () => {
  return await emperor.get('managewords');
};

export const createModeratedWord = async (term: string, type: WordCategory) => {
  return await emperor.post('managewords', { term, type });
};

export const editModeratedWord = async (
  term: string,
  type: WordCategory,
  uuid: string
) => {
  return await emperor.put(`managewords/${uuid}`, { term, type });
};

export const deleteModeratedWord = async (uuid: string, type: WordCategory) => {
  return await emperor.delete(`managewords/${uuid}`, { params: { type } });
};
